import { FooterBar } from './styled.js'
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa'
const Footer = () => (
  <footer>
    <FooterBar>
      <span>Hella Premium, Wenus 8, 80-010 Straszyn, Polska</span>
      <a href='tel:+48788850129'>
        <FaPhoneAlt /> +48 788 850 129
      </a>
      <a href='mailto:biuro@pieluchy.net'>
        <FaEnvelope /> biuro@pieluchy.net.pl
      </a>
    </FooterBar>
  </footer>
)

export default Footer
